import homeRoute from './home'

export const routerList = [
  ...homeRoute
]
